<transition name="open-alert"><CookieAlert :lang="lang" v-if="show &amp; !cookie" @setCookie="setCookie"></CookieAlert></transition>